import axios from "axios";

import { LOCALSTORAGE_KEYS } from "@/config";
// import { ENDPOINTS } from '@/config/api.enpoints';
import useAuthStore from "@/store/useAuthStore";

const url = import.meta.env.VITE_ENV_API_BASEURL || "http://localhost:5000"; // Corrected environment variable name
axios.defaults.withCredentials = true;

const apiClient = axios.create({
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Attach token to each request
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(LOCALSTORAGE_KEYS.token);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Extend AxiosRequestConfig to allow custom _retry flag
declare module "axios" {
  export interface AxiosRequestConfig {
    _retry?: boolean;
  }
}
// Attach response interceptor
import { jwtDecode } from "jwt-decode";
interface JwtPayload {
  name: string;
  role: string;
  id: string;
  tenantid: string;
}

apiClient.interceptors.response.use(
  (response) => {
    const newToken = response.headers["x-new-token"];
    if (newToken) {
      localStorage.setItem(LOCALSTORAGE_KEYS.token, newToken);
      apiClient.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
      try {
        const decoded = jwtDecode<JwtPayload>(newToken);
        const store = useAuthStore.getState();
        store.setRole(decoded.role);
        store.setTenantId(decoded.tenantid);
        store.setUserName(decoded.name);
        store.setId(decoded.id);
      } catch (decodeErr) {
        console.error("Failed to decode refreshed token:", decodeErr);
      }
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const newToken = error.response?.headers?.["x-new-token"];
    if (newToken) {
      localStorage.setItem(LOCALSTORAGE_KEYS.token, newToken);
      apiClient.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
      try {
        const decoded = jwtDecode<JwtPayload>(newToken);
        const store = useAuthStore.getState();
        store.setRole(decoded.role);
        store.setTenantId(decoded.tenantid);
        store.setUserName(decoded.name);
        store.setId(decoded.id);
      } catch (decodeErr) {
        console.error("Failed to decode refreshed token:", decodeErr);
      }
    }
    if (error.response?.status === 401 && !originalRequest._retry) {
      useAuthStore.getState().logout();
      window.location.href = "/login";
      // originalRequest._retry = true; // Mark request to avoid infinite retry

      // try {
      //   const refreshToken = localStorage.getItem(LOCALSTORAGE_KEYS.refreshToken);
      //   if (!refreshToken) {
      //     useAuthStore.getState().logout();
      //     return Promise.reject(error);
      //   }
      //   const res = await apiClient.post(ENDPOINTS.AUTH.refresh, {
      //     refreshToken,
      //   });
      //   const { accessToken } = res.data;
      //   localStorage.setItem(LOCALSTORAGE_KEYS.token, accessToken);
      //   // Update the headers for retry
      //   apiClient.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      //   originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;

      //   return apiClient(originalRequest); // Retry original request
      // } catch (err) {
      //   // Logout immediately on refresh failure
      //   useAuthStore.getState().logout();
      //   return Promise.reject(err);
      // }
    }

    // Ensure we provide a user-friendly error message if available from the backend
    if (error.response?.data?.message) {
      error.message = error.response.data.message;
    } else if (error.response?.data?.error) {
      error.message = error.response.data.error;
    } else if (!error.response) {
      error.message = 'Network error or server is unreachable. Please try again.';
    } else if (error.response?.status >= 500) {
      error.message = 'An unexpected server error occurred. Please try again later.';
    }

    return Promise.reject(error); // Pass other errors through
  },
);

export default apiClient;
